import React from 'react';
import { H2, H3, Section, RowBox, Box, Text, Span } from 'styles';
import { Button, Icon } from 'components';
import * as S from './LandingStyle';

export function Section1({ sectionRefs }) {
  return (
    <Section $margin="auto">
      <Box $padding="80px 40px" $tPadding="0 20px 40px" $mPadding="20px" $maxWidth={1600} $margin="auto">
      <H2 $display="none">빠르게 얻는 인사이트 N Survey</H2>
      <S.VisualBox>
        <Box $mTextAlien="center">
          <Box>
            <Button $type="badge">
              <Icon name="badgeIcon" />
              POWERED BY SKT AI SURVEY
            </Button>
          </Box>
          <Text $gap={8} $type="b72" $mType="b28" $padding="40px 0" $mPadding="20px 0" $display="grid" $mJustifyContent="center">
            빠르게 얻는
            <Span $type="b72" $mType="b28" $color="secondary100" $mPadding="0 8px">인사이트</Span>
            N-Survey
          </Text>
          <Text $type="20" $mType="16" $padding="16px 0 60px" $mPadding="16px" $color="gray600">
            N-Survey는 SK텔레콤의 T멤버십의 '미션' 탭의 '돈버는 설문'에서 진행되는
            <br />
            설문 서비스로 SK텔레콤의 1천6백만 고객을 패널로 하여 조사에 필요한
            <br />
            정밀한 타겟팅이 강점인 고품질-맞춤형 설문서비스입니다.
          </Text>
          <RowBox $gap={24} $mGap={8} $mJustifyContent="center" >
            <Button $type="common" onClick={() => sectionRefs.current['request'].scrollIntoView({ behavior: 'smooth' })}>
              <RowBox $gap={8} $alignItems="center">
                <Text $type="b18" $mType="b14">지금 바로 의뢰하기</Text>
                <Icon name="arrowRightWhite" />
              </RowBox>
            </Button>
            <Button $type="line" onClick={() => sectionRefs.current['about'].scrollIntoView({ behavior: 'smooth' })}>
              <Text $type="b18"  $mType="b14" $padding="0 24px" $mPadding="8px 24px">서비스 알아보기</Text>
            </Button>
          </RowBox>

        </Box>
        <Box $mPadding="0 17px">
          <Icon name="Main1" $mSvgHeight={300} $mSvgWidth="100%" />
        </Box>
      </S.VisualBox>
      </Box>
      <Box $backgroundColor="strong" $padding="40px" $mPadding="20px">
        <H2 $display="none">Stat Items</H2>
        <RowBox $gap={160} $mGap={8}  $justifyContent="center" $width="fit-content" $margin="auto">
          <Box $margin="auto" $padding="10px 16px">
            <Text $type="m38" $mType="m18" $color="secondary100" $textAlign="center">1,600만+</Text>
            <H3 $type="m15" $color="gray600" $textAlign="center">SKT 고객 패널</H3>
          </Box>
          <Box $margin="auto" $padding="10px 16px">
            <Text $type="m38" $mType="m18" $color="secondary100" $textAlign="center">1시간</Text>
            <H3 $type="m15" $color="gray600" $textAlign="center">평균 1,000명 응답</H3>
          </Box>
          <Box $margin="auto" $padding="10px 16px">
            <Text $type="m38" $mType="m18" $color="secondary100" $textAlign="center">AI 리포트</Text>
            <H3 $type="m15" $color="gray600" $textAlign="center">AI 결과 분석</H3>
          </Box>
        </RowBox>
      </Box>
    </Section>
  );
}
